export const DoppeActionTypeShareViewerLang = {
    defaultTexts: {
        shareTitle: 'Link Title',
        description: 'Describe the link you want people to share',
        shareButtonText: 'Share it',
    }
}